<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="RegisterView"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="register"
    :headerTitle="'Registers'|pgettext('Register')"
    :items="selectedRegisterId && selectedVersionId ? ds : []"
    export-to-csv
    :exportToCsvFilename="'register-entries'|pgettext('filename')"
    footer-totals
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    v-if="loaded"
    @command="evh_2248226175642056_command($event, {})"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <UcRegisterSelector
        v-model="states"
        cacheKey="registerView"
        @input="evh_6466705138206980_input($event, {})"
      >
      </UcRegisterSelector>
      <ItpButton
        :icon="$config.register.createEntry"
        :text="'Add entry...'|pgettext('Register')"
        size="sm"
        variant="light"
        class="mx-2"
        v-if="isRegisterSelected"
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpButton>
      <b-dropdown
        size="sm"
        variant="light"
        toggle-class="itp-button border"
        :tooltip="'Set status to selected items'|pgettext('Register')"
        :disabled="!selectedItems || !selectedItems.length || (
    actions.setStatus && actions.setStatus.isRunning
  )"
        class="mx-2"
        v-if="statuses && statuses.length"
      >
        <span
          slot="button-content"
        >
          <b-spinner
            small
            type="grow"
            class="mr-1"
            v-if="actions.setStatus.isRunning"
          >
          </b-spinner>
          <ItpText
            :text="'Set status'|pgettext('Register')"
            class="mx-1"
          >
          </ItpText>
        </span>
        <b-dropdown-item-button
          :disabled="!selectedItems || !selectedItems.length"
          :key="status"
          v-for="status in statuses"
          @click.prevent.stop="evh_5382094220310827_clickPreventStop($event, {status})"
        >
          <ItpText
            :text="status"
          >
          </ItpText>
        </b-dropdown-item-button>
        <hr>
        </hr>
        <b-dropdown-item-button
          :disabled="!selectedItems || !selectedItems.length"
          @click.prevent.stop="evh_8704926098283402_clickPreventStop($event, {})"
        >
          <ItpText
            :text="'Clear status'|pgettext('Register')"
          >
          </ItpText>
        </b-dropdown-item-button>
      </b-dropdown>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "registers",
    path: "/registers",
    component: "RegisterView"
  }
)

addRoute(
  {
    name: "letterRegister",
    path: "/letter-register",
    component: "RegisterView"
  }
)

addRoute(
  {
    name: "invoiceRegister",
    path: "/invoice-register",
    component: "RegisterView"
  }
)

@Component()
export default class RegisterView extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_states = new ComponentValueCache(this, "states", "RegisterView.states");
  }

  getQueryParameters(...args: any[]) {
    return {
      sort_mode: 'desc',
      register_id: this.selectedRegisterId,
      version_id: this.selectedVersionId
    }
  }

  invoiceTypeBadgeClass(...args: any[]) {
    const [row] = args;
    const cc = this.$config.invoice.types.colorCodes[row.invoice_type];
    return `bg-${cc.bg} text-${cc.text}`
  }

  priorityBadgeClass(...args: any[]) {
    const [row] = args;
    const priority = row.priority;

    if (priority == 1) {
      return `border border-purple-500 text-purple-500`
    }

    if (priority == 2) {
      return `border border-red-500 text-red-500`
    }
  }

  invoiceFormatter(...args: any[]) {
    const [grid] = args;

    if (!this._invoiceFormatter) {
      this._invoiceFormatter = grid.ALL_FORMATTERS.chain({
        formatters: [
          {
            name: 'template',
            format: '{{ document.invoice_number }}'
          },
          {
            name: 'link',
            href: '#',
            className: 'command-link'
          },
          {
            name: 'cellclass',
            value: row => ({
              'font-weight-bold': true,
              'bg-yellow-500 text-yellow-800': row.is_corrected,
              'bg-red-300 text-red-800': row.is_reversed,
            })
          }
        ]
      })
    }
    return this._invoiceFormatter;
  }

  referenceNumberFormatter(...args: any[]) {
    const [grid] = args;

    if (!this._referenceNumberFormatter) {
      this._referenceNumberFormatter = grid.ALL_FORMATTERS.getvalue({
        field: 'reference_number',
        source: 'row'
      });
    }
    return this._referenceNumberFormatter;
  }

  documentFormatter(...args: any[]) {
    const [row, cell, value, columnDef, data, grid] = args;
    if (value && value.invoice_number) {
      return this.invoiceFormatter(grid)(...args);
    }

    if (data.reference_number) {
      return this.referenceNumberFormatter(grid)(
        row, cell, data.reference_number, columnDef, data, grid
      );
    }
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  states!: any;
  selectedItems!: any;
  statuses!: any;

  async $$load_statuses() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'register-entry:status' } }).then(data => _.map(data, p => p.name))
  }

  selectedStatus!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_register_entries', { parameters: this.getQueryParameters })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;

  async $$load_b_2248226175642056_columns() {
    return [{
      field: "entry_number",
      name: this.$fn.pgettext("Register", "No."),
      type: "command",
      formatter: [{
        name: "chain",
        formatters: [{
          name: "link",
          href: "#",
        }
          ,
        {
          name: "cellclass",
          value: (row) => ({
            'font-weight-bold': true,
            'bg-yellow-200': !row.locked,
            'bg-gray-dark-100': row.locked,
            'text-decoration-line-through': row.void,
          }),
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    {
      field: "entry_date",
      name: this.$fn.pgettext("Register", "Date"),
      type: "date",
    }
      ,
    {
      field: "direction",
      name: this.$fn.pgettext("Register", "Direction"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "gettext",
          context: "RegisterEntryDirection",
          conversion: "StartCase",
          filterInput: true,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "document_type",
      name: this.$fn.pgettext("Register", "Document type"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "gettext",
          context: "RegisterDocumentType",
          conversion: "StartCase",
          filterInput: true,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "attachments",
      name: this.$fn.pgettext("Register", "Attachments"),
      type: "command",
      formatter: {
        name: "attachment",
      }
      ,
    }
      ,
    {
      field: "delivery_modes",
      name: this.$fn.pgettext("Register", "Delivery mode"),
      formatter: {
        name: "join",
        separator: ", ",
      }
      ,
    }
      ,
    {
      field: "clerk",
      name: this.$fn.pgettext("Register", "Clerk"),
    }
      ,
    {
      field: "project",
      name: this.$fn.pgettext("Register", "Project"),
      formatter: {
        name: "chain",
        mode: "mapReduce",
        formatterContext: "item",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "code,name",
            source: "value",
            separator: " • ",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "project",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "priority",
      name: this.$fn.pgettext("Register", "Priority"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "mapvalue",
          mapping: {
            0: this.$fn.pgettext("Priority", "normal"),
            1: this.$fn.pgettext("Priority", "important"),
            2: this.$fn.pgettext("Priority", "urgent"),
          }
          ,
        }
          ,
        {
          name: "badge",
          pill: true,
          badgeClass: this.priorityBadgeClass,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "document",
      name: this.$fn.pgettext("Register", "Document"),
      type: "command",
      formatter: this.documentFormatter,
    }
      ,
    {
      field: "partner",
      name: this.$fn.pgettext("Register", "Partner"),
      formatter: {
        name: "chain",
        mode: "mapReduce",
        formatterContext: "item",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "name",
            source: "value",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "company",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "subject",
      name: this.$fn.pgettext("Register", "Subject"),
    }
      ,
    {
      field: "ref_entry_number",
      name: this.$fn.pgettext("Register", "Ref."),
      type: "command",
      formatter: [{
        name: "chain",
        formatters: [{
          name: "link",
          href: "#",
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    {
      field: "status",
      name: this.$fn.pgettext("Register", "Status"),
    }
      ,
    {
      field: "categories",
      name: this.$fn.pgettext("Register", "Category"),
    }
      ,
    {
      field: "delivery_date",
      name: this.$fn.pgettext("Register", "Delivery date"),
      type: "date",
    }
      ,
    {
      field: "notes",
      name: this.$fn.pgettext("Register", "Notes"),
    }
      ,
    {
      field: "created_at",
      name: this.$fn.pgettext("BrowserColumn", "Create time"),
      formatter: "datetime",
    }
      ,
    ]
  }

  dataMembers = ['states', 'selectedItems', 'statuses', 'selectedStatus', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        states: {
          selectedRegisterId: null,
          selectedVersionId: null,
        }
        ,
        selectedItems: [
        ]
        ,
        statuses: null,
        selectedStatus: null,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: null,
      },
    }
  }

  get selectedRegisterId() {
    if (this.loaded) {

      return this.states.selectedRegisterId
    }
    return null;
  }

  get selectedVersionId() {
    if (this.loaded) {

      return this.states.selectedVersionId
    }
    return null;
  }

  get isRegisterSelected() {
    if (this.loaded) {

      return this.selectedRegisterId && this.selectedVersionId
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Register", "Registers"),
        icon: this.$config.register.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_5564_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5564, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_5568_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_5568, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_2248226175642056_reloadSlickgrid_5570_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_5570, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async evh_2248226175642056_close_5569_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_close_5569, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_2248226175642056_showModal_5566_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_5566, alias=showRegisterEntryModal
    return {
      name: "RegisterEntry",
      props: {
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_5565_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_5565, alias=undefined
    return $event.data.column.id === 'entry_number'
  }

  async act_2248226175642056_reloadSlickgrid_5574_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_5574, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_2248226175642056_reloadSlickgrid_5576_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_5576, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async evh_2248226175642056_close_5575_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_close_5575, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_2248226175642056_showModal_5572_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_5572, alias=showRefEntryModal
    return {
      name: "RegisterEntry",
      props: {
        oid: $event.data.data.ref_entry_id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_5571_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_5571, alias=undefined
    return $event.data.column.id === 'ref_entry_number'
  }

  async act_2248226175642056_script_5578_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_5578, alias=undefined
    this.$app.attachments.downloadAttachmentFromSlickCommand($event)
  }

  async act_2248226175642056_script_5578_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_5578, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_5578_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_command_5577_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_5577, alias=undefined
    return $event.data.column.id === 'attachments'
  }

  async act_2248226175642056_showModal_5580_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_5580, alias=showInvoiceModal
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.document.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_5579_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_5579, alias=undefined
    return $event.data.column.id === 'document' &&
      !!$event.data.data.document &&
      !!$event.data.data.document.invoice_number
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_5582_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_5582, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_reloadSlickgrid_5584_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6466705138206980_reloadSlickgrid_5584, alias=undefined
    return {
      grid: "register",
    }
  }

  async evh_6466705138206980_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_input.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_reloadSlickgrid_5588_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8320016629450276_reloadSlickgrid_5588, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_8320016629450276_reloadSlickgrid_5590_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8320016629450276_reloadSlickgrid_5590, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async evh_8320016629450276_close_5589_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_5589, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_8320016629450276_showModal_5586_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_5586, alias=undefined
    return {
      name: "RegisterEntry",
      props: {
        registerId: this.states.selectedRegisterId,
        versionId: this.states.selectedVersionId,
      }
      ,
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  async act_5382094220310827_setData_5592_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5382094220310827_setData_5592, alias=undefined
    return {
      path: "selectedStatus",
      value: $event.scope.status,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5382094220310827_reloadSlickgrid_5596_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_5382094220310827_reloadSlickgrid_5596, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_5382094220310827_request_5594_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_5382094220310827_request_5594, alias=setStatus
    return {
      operation: "bulk_update_register_entry",
      data: _.map(this.selectedItems, p => ({ id: p.id, status: this.selectedStatus })),
    }
  }

  async evh_5382094220310827_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5382094220310827_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8704926098283402_setData_5598_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_8704926098283402_setData_5598, alias=undefined
    return {
      path: "selectedStatus",
      value: null,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_8704926098283402_reloadSlickgrid_5602_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8704926098283402_reloadSlickgrid_5602, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_8704926098283402_request_5600_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8704926098283402_request_5600, alias=setStatus
    return {
      operation: "bulk_update_register_entry",
      data: _.map(this.selectedItems, p => ({ id: p.id, status: this.selectedStatus })),
    }
  }

  async evh_8704926098283402_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8704926098283402_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5564: actions.CloseModalAction;
    evh_7315092382398562_close_5563: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_reloadSlickgrid_5568: actions.ReloadSlickgridAction;
    evh_2248226175642056_saved_5567: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_5570: actions.ReloadSlickgridAction;
    evh_2248226175642056_close_5569: actions.EventHandlerImpl;
    act_2248226175642056_showModal_5566: actions.ShowModalAction;
    evh_2248226175642056_command_5565: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_5574: actions.ReloadSlickgridAction;
    evh_2248226175642056_saved_5573: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_5576: actions.ReloadSlickgridAction;
    evh_2248226175642056_close_5575: actions.EventHandlerImpl;
    act_2248226175642056_showModal_5572: actions.ShowModalAction;
    evh_2248226175642056_command_5571: actions.EventHandlerImpl;
    act_2248226175642056_script_5578: actions.ScriptAction;
    evh_2248226175642056_command_5577: actions.EventHandlerImpl;
    act_2248226175642056_showModal_5580: actions.ShowModalAction;
    evh_2248226175642056_command_5579: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_2248226175642056_setData_5582: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_5581: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_6466705138206980_reloadSlickgrid_5584: actions.ReloadSlickgridAction;
    evh_6466705138206980_input_5583: actions.EventHandlerImpl;
    evh_6466705138206980_input: actions.EventHandlerGroup;
    act_8320016629450276_reloadSlickgrid_5588: actions.ReloadSlickgridAction;
    evh_8320016629450276_saved_5587: actions.EventHandlerImpl;
    act_8320016629450276_reloadSlickgrid_5590: actions.ReloadSlickgridAction;
    evh_8320016629450276_close_5589: actions.EventHandlerImpl;
    act_8320016629450276_showModal_5586: actions.ShowModalAction;
    evh_8320016629450276_click_5585: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
    act_5382094220310827_setData_5592: actions.SetDataAction;
    evh_5382094220310827_clickPreventStop_5591: actions.EventHandlerImpl;
    act_5382094220310827_reloadSlickgrid_5596: actions.ReloadSlickgridAction;
    evh_5382094220310827_success_5595: actions.EventHandlerImpl;
    act_5382094220310827_request_5594: actions.RequestAction;
    evh_5382094220310827_clickPreventStop_5593: actions.EventHandlerImpl;
    evh_5382094220310827_clickPreventStop: actions.EventHandlerGroup;
    act_8704926098283402_setData_5598: actions.SetDataAction;
    evh_8704926098283402_clickPreventStop_5597: actions.EventHandlerImpl;
    act_8704926098283402_reloadSlickgrid_5602: actions.ReloadSlickgridAction;
    evh_8704926098283402_success_5601: actions.EventHandlerImpl;
    act_8704926098283402_request_5600: actions.RequestAction;
    evh_8704926098283402_clickPreventStop_5599: actions.EventHandlerImpl;
    evh_8704926098283402_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5564 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5564_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5563 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5564,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5563],
      }
    );
    const act_2248226175642056_reloadSlickgrid_5568 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_5568_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_saved_5567 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_5568,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_reloadSlickgrid_5570 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_5570_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_close_5569 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_5570,
        event: "close",
        when: this.evh_2248226175642056_close_5569_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_showModal_5566 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_5566_getActionArgs,
        displayName: "showRegisterEntryModal",
        events: [evh_2248226175642056_saved_5567, evh_2248226175642056_close_5569],
      }
    );
    const evh_2248226175642056_command_5565 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_5566,
        event: "command",
        when: this.evh_2248226175642056_command_5565_getWhen,
        displayName: "showRegisterEntryModal",
      }
    );
    const act_2248226175642056_reloadSlickgrid_5574 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_5574_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_saved_5573 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_5574,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_reloadSlickgrid_5576 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_5576_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_close_5575 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_5576,
        event: "close",
        when: this.evh_2248226175642056_close_5575_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_showModal_5572 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_5572_getActionArgs,
        displayName: "showRefEntryModal",
        events: [evh_2248226175642056_saved_5573, evh_2248226175642056_close_5575],
      }
    );
    const evh_2248226175642056_command_5571 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_5572,
        event: "command",
        when: this.evh_2248226175642056_command_5571_getWhen,
        displayName: "showRefEntryModal",
      }
    );
    const act_2248226175642056_script_5578 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_5578_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_5577 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_5578,
        event: "command",
        when: this.evh_2248226175642056_command_5577_getWhen,
        displayName: "script",
      }
    );
    const act_2248226175642056_showModal_5580 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_5580_getActionArgs,
        displayName: "showInvoiceModal",
        events: [],
      }
    );
    const evh_2248226175642056_command_5579 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_5580,
        event: "command",
        when: this.evh_2248226175642056_command_5579_getWhen,
        displayName: "showInvoiceModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_5565, evh_2248226175642056_command_5571, evh_2248226175642056_command_5577, evh_2248226175642056_command_5579],
      }
    );
    const act_2248226175642056_setData_5582 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_5582_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_5581 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_5582,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_5581],
      }
    );
    const act_6466705138206980_reloadSlickgrid_5584 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6466705138206980_reloadSlickgrid_5584_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_input_5583 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_reloadSlickgrid_5584,
        event: "input",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_6466705138206980_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_input_5583],
      }
    );
    const act_8320016629450276_reloadSlickgrid_5588 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8320016629450276_reloadSlickgrid_5588_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_8320016629450276_saved_5587 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadSlickgrid_5588,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8320016629450276_reloadSlickgrid_5590 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8320016629450276_reloadSlickgrid_5590_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_8320016629450276_close_5589 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadSlickgrid_5590,
        event: "close",
        when: this.evh_8320016629450276_close_5589_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_8320016629450276_showModal_5586 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_5586_getActionArgs,
        events: [evh_8320016629450276_saved_5587, evh_8320016629450276_close_5589],
      }
    );
    const evh_8320016629450276_click_5585 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_5586,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_5585],
      }
    );
    const act_5382094220310827_setData_5592 = new actions.SetDataAction(
      {
        actionArgs: this.act_5382094220310827_setData_5592_getActionArgs,
        events: [],
      }
    );
    const evh_5382094220310827_clickPreventStop_5591 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_setData_5592,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const act_5382094220310827_reloadSlickgrid_5596 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_5382094220310827_reloadSlickgrid_5596_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_5382094220310827_success_5595 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_reloadSlickgrid_5596,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_5382094220310827_request_5594 = new actions.RequestAction(
      {
        actionArgs: this.act_5382094220310827_request_5594_getActionArgs,
        displayName: "setStatus",
        events: [evh_5382094220310827_success_5595],
      }
    );
    const evh_5382094220310827_clickPreventStop_5593 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_request_5594,
        event: "click.prevent.stop",
        displayName: "setStatus",
      }
    );
    const evh_5382094220310827_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5382094220310827_clickPreventStop_5591, evh_5382094220310827_clickPreventStop_5593],
      }
    );
    const act_8704926098283402_setData_5598 = new actions.SetDataAction(
      {
        actionArgs: this.act_8704926098283402_setData_5598_getActionArgs,
        events: [],
      }
    );
    const evh_8704926098283402_clickPreventStop_5597 = new actions.EventHandlerImpl(
      {
        action: act_8704926098283402_setData_5598,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const act_8704926098283402_reloadSlickgrid_5602 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8704926098283402_reloadSlickgrid_5602_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_8704926098283402_success_5601 = new actions.EventHandlerImpl(
      {
        action: act_8704926098283402_reloadSlickgrid_5602,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8704926098283402_request_5600 = new actions.RequestAction(
      {
        actionArgs: this.act_8704926098283402_request_5600_getActionArgs,
        displayName: "setStatus",
        events: [evh_8704926098283402_success_5601],
      }
    );
    const evh_8704926098283402_clickPreventStop_5599 = new actions.EventHandlerImpl(
      {
        action: act_8704926098283402_request_5600,
        event: "click.prevent.stop",
        displayName: "setStatus",
      }
    );
    const evh_8704926098283402_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8704926098283402_clickPreventStop_5597, evh_8704926098283402_clickPreventStop_5599],
      }
    );
    return {
      act_7315092382398562_closeModal_5564,
      evh_7315092382398562_close_5563,
      evh_7315092382398562_close,
      act_2248226175642056_reloadSlickgrid_5568,
      evh_2248226175642056_saved_5567,
      act_2248226175642056_reloadSlickgrid_5570,
      evh_2248226175642056_close_5569,
      act_2248226175642056_showModal_5566,
      evh_2248226175642056_command_5565,
      act_2248226175642056_reloadSlickgrid_5574,
      evh_2248226175642056_saved_5573,
      act_2248226175642056_reloadSlickgrid_5576,
      evh_2248226175642056_close_5575,
      act_2248226175642056_showModal_5572,
      evh_2248226175642056_command_5571,
      act_2248226175642056_script_5578,
      evh_2248226175642056_command_5577,
      act_2248226175642056_showModal_5580,
      evh_2248226175642056_command_5579,
      evh_2248226175642056_command,
      act_2248226175642056_setData_5582,
      evh_2248226175642056_selectedRowsChanged_5581,
      evh_2248226175642056_selectedRowsChanged,
      act_6466705138206980_reloadSlickgrid_5584,
      evh_6466705138206980_input_5583,
      evh_6466705138206980_input,
      act_8320016629450276_reloadSlickgrid_5588,
      evh_8320016629450276_saved_5587,
      act_8320016629450276_reloadSlickgrid_5590,
      evh_8320016629450276_close_5589,
      act_8320016629450276_showModal_5586,
      evh_8320016629450276_click_5585,
      evh_8320016629450276_click,
      act_5382094220310827_setData_5592,
      evh_5382094220310827_clickPreventStop_5591,
      act_5382094220310827_reloadSlickgrid_5596,
      evh_5382094220310827_success_5595,
      act_5382094220310827_request_5594,
      evh_5382094220310827_clickPreventStop_5593,
      evh_5382094220310827_clickPreventStop,
      act_8704926098283402_setData_5598,
      evh_8704926098283402_clickPreventStop_5597,
      act_8704926098283402_reloadSlickgrid_5602,
      evh_8704926098283402_success_5601,
      act_8704926098283402_request_5600,
      evh_8704926098283402_clickPreventStop_5599,
      evh_8704926098283402_clickPreventStop,
      reloadSlickgrid: act_8704926098283402_reloadSlickgrid_5602,
      showRegisterEntryModal: act_2248226175642056_showModal_5566,
      showRefEntryModal: act_2248226175642056_showModal_5572,
      showInvoiceModal: act_2248226175642056_showModal_5580,
      setStatus: act_8704926098283402_request_5600,
    }
  }
}

Vue.component("RegisterView", RegisterView);

</script>